(function(window, app) {
  "use strict";

  // Login & Signup
  app.router.add({
    "(:page)(/)": [
      "authentication",
      {
        regexp: {
          page: /(login|signup|reset|forgot)?/
        }
      }
    ]
  });

  app.router.add({
    "fb-auth(/)": ["oauth-auth", {}],
    "oauth-auth(/)": ["oauth-auth", {}]
  });
})(window, window.app);
